<h2 mat-dialog-title>{{ data.etiqueta ? 'Editar etiqueta' : 'Nova etiqueta' }}</h2>

<div mat-dialog-content class="dialog-tarefa-etiqueta__conteudo">
  <mat-form-field appearance="outline">
    <mat-label>Nome da etiqueta</mat-label>
    <input matInput [(ngModel)]="noEtiqueta" maxlength="60" (keyup.enter)="salvar()">
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Cor da etiqueta</mat-label>
    <input matInput [value]="noCor.substring(1)" readonly>
    <button mat-icon-button matSuffix type="button" [matMenuTriggerFor]="menuCor" [style.color]="noCor"
      aria-label="Selecionar cor da etiqueta"><mat-icon>palette</mat-icon></button>
  </mat-form-field>
</div>

<mat-menu #menuCor="matMenu">
  <ng-template matMenuContent>
    <color-picker (click)="$event.stopPropagation()" [(value)]="noCor" [(format)]="formatoCor"
      [hideAlpha]="true"></color-picker>
  </ng-template>
</mat-menu>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!noEtiqueta.trim()"
    (click)="salvar()">Salvar</button>
</div>